/* Meubelhunter — Cart drawer
   Zelfstandige slide-in winkelwagen. Hangt niet af van Empire's cart-JS.
   - Onderschept add-to-cart forms + de header cart-knop
   - Muteert via Shopify cart-AJAX (/cart/add.js, /cart/change.js) en vraagt in
     dezelfde request de verse section-HTML op (sections-param) -> geen race/cache.
*/
(function () {
  'use strict';

  var SECTION = 'mh-cart-drawer';
  var routes = (window.Theme && window.Theme.routes) || {};
  var ROOT = (routes.root_url && routes.root_url !== '/') ? routes.root_url : '';
  var CART_URL = routes.cart_url || (ROOT + '/cart');
  var ADD_URL = routes.cart_add_url || (ROOT + '/cart/add');
  var CHANGE_URL = routes.cart_change_url || (ROOT + '/cart/change');
  var UPDATE_URL = routes.cart_update_url || (ROOT + '/cart/update');

  var lastFocus = null;
  var busy = false;
  var appliedDiscount = ''; // laatst bekende toegepaste (applicable) kortingscode

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  /* ---------- open / close ---------- */
  function open() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mh-cd-open');
    var panel = d.querySelector('.mh-cd__panel');
    if (panel) { panel.setAttribute('tabindex', '-1'); panel.focus(); }
  }
  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mh-cd-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- helpers ---------- */
  function setBusy(state) {
    busy = state;
    var d = drawer();
    if (!d) return;
    if (state) d.setAttribute('data-cd-loading', '');
    else d.removeAttribute('data-cd-loading');
  }

  function updateHeaderCount(count) {
    var nodes = document.querySelectorAll('[data-header-cart-count], .site-header-cart--count');
    nodes.forEach(function (el) {
      if (el.hasAttribute('data-header-cart-count')) {
        el.setAttribute('data-header-cart-count', count > 0 ? count : '');
      } else {
        el.textContent = count > 0 ? count : '';
      }
      el.classList.toggle('visible', count > 0);
    });
  }

  // Verse section-HTML in de huidige drawer plaatsen.
  function applySection(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cd-content]');
    var current = document.querySelector('[data-cd-content]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
    }
    var countEl = document.querySelector('[data-cd-count]');
    updateHeaderCount(countEl ? parseInt(countEl.textContent, 10) || 0 : 0);
    renderDiscountChip(); // chip herstellen na elke her-render (sectie kan 'm niet voor alle code-typen renderen)
  }

  /* ---------- kortingscode-status (uit de cart-JSON, niet uit de sectie) ----------
     Sommige geldige codes (gratis verzending, order-/app-kortingen) geven GEEN
     cart_level_discount_application in de cart, waardoor de sectie geen chip rendert.
     De AJAX-cart geeft wél `discount_codes: [{code, applicable}]`; dat is de bron van waarheid. */
  function discountApplicable(cart, code) {
    var dc = cart && cart.discount_codes;
    if (!dc) return false;
    var u = (code || '').toUpperCase();
    for (var i = 0; i < dc.length; i++) {
      if ((dc[i].code || '').toUpperCase() === u && dc[i].applicable) return true;
    }
    return false;
  }
  function syncDiscount(cart) {
    var dc = cart && cart.discount_codes;
    appliedDiscount = '';
    if (dc) for (var i = 0; i < dc.length; i++) { if (dc[i].applicable) { appliedDiscount = dc[i].code; break; } }
  }
  function renderDiscountChip() {
    var wrap = document.querySelector('[data-cd-disc]');
    if (!wrap || !appliedDiscount) return;
    if (wrap.querySelector('[data-cd-disc-remove]')) return; // sectie rendert de chip al (cart-level code)
    var form = wrap.querySelector('[data-cd-disc-form]');
    if (!form) return;
    var box = document.createElement('div');
    box.className = 'mh-cd__disc-applied';
    var chip = document.createElement('span');
    chip.className = 'mh-cd__disc-chip';
    chip.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#236B1D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 12.3 12 3.7A2 2 0 0 0 10.6 3H4a1 1 0 0 0-1 1v6.6a2 2 0 0 0 .6 1.4l8.6 8.6a2 2 0 0 0 2.8 0l5.6-5.6a2 2 0 0 0 0-2.7Z"/><circle cx="7.5" cy="7.5" r="1"/></svg>';
    chip.appendChild(document.createTextNode(' ' + appliedDiscount));
    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'mh-cd__disc-remove';
    rm.setAttribute('data-cd-disc-remove', '');
    rm.setAttribute('data-code', appliedDiscount);
    rm.setAttribute('aria-label', 'Kortingscode ' + appliedDiscount + ' verwijderen');
    rm.textContent = '✕';
    box.appendChild(chip);
    box.appendChild(rm);
    form.parentNode.replaceChild(box, form);
  }

  // Sectie uit een cart-AJAX-response halen. Shopify kan de HTML als string of
  // als { id: { ... } }-object teruggeven; we ondersteunen beide vormen.
  function sectionFromResponse(json) {
    if (!json || !json.sections) return null;
    var s = json.sections[SECTION];
    if (!s) return null;
    return typeof s === 'string' ? s : (s.html || s.text || null);
  }

  /* ---------- losse refresh (verse drawer zonder cart-mutatie) ----------
     Let op: /cart?sections=<static-section> geeft een in theme.liquid via
     {% section %} geplaatste sectie NIET terug. /cart/update.js met een lege body
     (alleen sections/sections_url) muteert niets én levert wél de verse section-HTML. */
  function refresh() {
    return fetch(ROOT + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
      body: JSON.stringify({ sections: SECTION, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) { syncDiscount(j); applySection(sectionFromResponse(j)); })
      .catch(function () {});
  }

  /* ---------- cart mutations ---------- */
  function addToCart(form) {
    if (busy) return;
    setBusy(true);
    var data = new FormData(form);
    // Eetkamerstoelen/barkrukken e.d.: rond de hoeveelheid af op een veelvoud
    // van de stapgrootte van de quantity-input (per 2 -> altijd even).
    var qInput = form.querySelector('[data-quantity-input], input[name="quantity"]');
    var addStep = qInput ? (parseInt(qInput.getAttribute('step'), 10) || parseInt(qInput.getAttribute('data-increment-value'), 10) || 1) : 1;
    if (addStep > 1) {
      var q = parseInt(data.get('quantity'), 10) || addStep;
      var norm = Math.ceil(q / addStep) * addStep;
      if (norm < addStep) norm = addStep;
      data.set('quantity', norm);
    }
    data.append('sections', SECTION);
    data.append('sections_url', window.location.pathname);
    fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        setBusy(false);
        if (!res.ok) {
          alert(res.body && res.body.description ? res.body.description : 'Toevoegen mislukt.');
          return;
        }
        var html = sectionFromResponse(res.body);
        if (html) { applySection(html); open(); }
        else { refresh().then(open); } // fallback
      })
      .catch(function () { setBusy(false); });
  }

  // Meerdere items in één keer (bundel "Voeg alle 3 toe"). Zelfde sections-flow
  // als addToCart -> verse drawer-HTML direct uit de response (geen refresh-race).
  function addItems(items) {
    if (busy || !items || !items.length) return Promise.resolve();
    setBusy(true);
    return fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
      body: JSON.stringify({ items: items, sections: SECTION, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        setBusy(false);
        if (!res.ok) {
          alert(res.body && res.body.description ? res.body.description : 'Toevoegen mislukt.');
          return;
        }
        var html = sectionFromResponse(res.body);
        if (html) { applySection(html); open(); }
        else { refresh().then(open); }
      })
      .catch(function () { setBusy(false); });
  }

  // Kleine publieke API zodat andere scripts (bv. de PDP-bundel) via dezelfde
  // verse-HTML-flow kunnen toevoegen/openen.
  window.MHCartDrawer = { addItems: addItems, open: open, refresh: refresh };

  function changeQty(key, qty) {
    if (busy) return;
    setBusy(true);
    fetch(CHANGE_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      cache: 'no-store',
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: SECTION,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        setBusy(false);
        syncDiscount(json);
        var html = sectionFromResponse(json);
        if (html) applySection(html);
        else refresh(); // fallback
      })
      .catch(function () { setBusy(false); });
  }

  /* ---------- kortingscode ---------- */
  function discMsg(text, isError) {
    var m = document.querySelector('[data-cd-disc-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-error', !!isError);
    m.classList.toggle('is-ok', !!text && !isError);
  }
  function appliedCodeInDom() {
    var btn = document.querySelector('[data-cd-disc-remove]');
    return btn ? (btn.getAttribute('data-code') || '') : '';
  }

  // Officiële Cart AJAX API (changelog 2025-05): /cart/update.js accepteert een
  // `discount`-parameter -> toepassen ('CODE'), meerdere ('a,b') of alles wissen ('').
  // In dezelfde call vragen we `sections` mee -> muteren + verse drawer-HTML in één
  // request, mét de korting gereflecteerd (cart.discount_codes / *_discount_applications).
  function updateCart(body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(UPDATE_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
  }

  function applyDiscount(code) {
    if (busy) return;
    code = (code || '').trim();
    if (!code) return;
    setBusy(true);
    discMsg('', false);
    updateCart({ discount: code })
      .then(function (res) {
        setBusy(false);
        var cart = res.body || {};
        var ok = discountApplicable(cart, code);
        // Geldigheid komt uit de cart-JSON (discount_codes[].applicable), NIET uit de
        // sectie-chip: gratis-verzending/order-/app-kortingen geven geen cart-level
        // application maar zijn wél geldig (en verrekenen bij het afrekenen).
        syncDiscount(cart);
        var html = sectionFromResponse(cart);
        if (html) applySection(html); else refresh();
        if (ok) {
          discMsg('Kortingscode toegepast.', false);
        } else {
          updateCart({ discount: '' }); // niet-toepasbare code weer opruimen
          appliedDiscount = '';
          discMsg('Deze code is niet geldig of niet van toepassing.', true);
          var inp = document.querySelector('[data-cd-disc-input]');
          if (inp) { inp.value = code; inp.focus(); }
        }
      })
      .catch(function () { setBusy(false); discMsg('Er ging iets mis. Probeer opnieuw.', true); });
  }

  // Alle kortingscodes wissen (we tonen er max één) -> discount: ''.
  function removeDiscount() {
    if (busy) return;
    setBusy(true);
    updateCart({ discount: '' })
      .then(function (res) {
        setBusy(false);
        syncDiscount(res.body || {}); // -> appliedDiscount ''
        var html = sectionFromResponse(res.body);
        if (html) applySection(html); else refresh();
        discMsg('', false);
      })
      .catch(function () { setBusy(false); });
  }

  /* ---------- event wiring ---------- */
  // Kortingscode-formulier: Enter/submit -> toepassen (geen page-reload).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-cd-disc-form]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var di = form.querySelector('[data-cd-disc-input]');
    applyDiscount(di ? di.value : '');
  }, true);

  // Add-to-cart: capture-fase zodat we vóór Empire's eigen handler zitten.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    var isAdd = action.indexOf('/cart/add') !== -1 || form.getAttribute('data-cart-add') !== null;
    if (!isAdd) return;
    if (form.hasAttribute('data-no-drawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  // Add-to-cart via KNOP-klik (capture). Empire's sticky-knop roept form.submit()
  // programmatisch aan -> dat vuurt geen submit-event af. Daarom vangen we ook de klik,
  // zodat de drawer overal opent i.p.v. een redirect naar /cart.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form--atc-button, [data-sticky-atc-btn], button[name="add"], [data-add-to-cart]');
    if (!btn) return;
    // Dynamische checkout-knoppen (Shop Pay / PayPal) met rust laten.
    if (btn.closest('.shopify-payment-button')) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var form = btn.closest('form[action*="/cart/add"]')
      || btn.closest('form[data-product-form]')
      || document.querySelector('form[data-product-form], form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-no-drawer')) return;
    // Geen variant gekozen -> laat het thema zijn eigen validatie tonen.
    var idField = form.querySelector('[name="id"]');
    if (idField && (idField.value === 'not-selected' || idField.value === '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  // Header cart-knop opent de drawer i.p.v. naar /cart te gaan.
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('.site-header-cart--button, [data-cart-drawer-open]');
    if (cartBtn) {
      e.preventDefault();
      refresh().then(open);
      return;
    }

    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }

    // Kortingscode toepassen (knop) / verwijderen.
    if (e.target.closest('[data-cd-disc-apply]')) {
      e.preventDefault();
      var di = document.querySelector('[data-cd-disc-input]');
      applyDiscount(di ? di.value : '');
      return;
    }
    if (e.target.closest('[data-cd-disc-remove]')) {
      e.preventDefault();
      removeDiscount();
      return;
    }

    var inc = e.target.closest('[data-cd-inc]');
    var dec = e.target.closest('[data-cd-dec]');
    var rem = e.target.closest('[data-cd-remove]');
    if (inc || dec || rem) {
      var trigger = inc || dec || rem;
      var key = trigger.getAttribute('data-cd-key');
      var item = trigger.closest('[data-cd-item]');
      if (!item || !key) return;
      var qtyEl = item.querySelector('[data-cd-qty]');
      var cur = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      var step = parseInt(item.getAttribute('data-cd-step'), 10) || 1;
      if (inc) {
        // normaliseer omhoog naar het volgende veelvoud van step
        changeQty(key, (Math.floor(cur / step) + 1) * step);
      } else if (dec) {
        var next = (Math.ceil(cur / step) - 1) * step;
        changeQty(key, next < step ? 0 : next); // onder het minimum => verwijderen
      } else {
        changeQty(key, 0);
      }
    }
  });

  // Escape sluit de drawer.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) close();
    }
  });

  /* ---------- sticky add-to-cart balk (PDP, mobiel) ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-mh-satc]');
    if (!bar) return;
    var atcBtn = document.querySelector('.product-form--atc-button');
    var idField = document.querySelector('[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]');

    var variants = {};
    var vEl = bar.querySelector('[data-mh-satc-variants]');
    if (vEl) { try { variants = JSON.parse(vEl.textContent); } catch (e) {} }

    var titleEl = bar.querySelector('[data-mh-satc-title]');
    var priceEl = bar.querySelector('[data-mh-satc-price]');
    var imgEl = bar.querySelector('[data-mh-satc-img]');
    var addBtn = bar.querySelector('[data-mh-satc-add]');
    var productTitle = bar.getAttribute('data-product-title') || '';
    var hasVariants = bar.getAttribute('data-has-variants') === 'true';

    function sync(id) {
      var key = id != null ? ('' + id) : (idField ? idField.value : null);
      if (!key) return;
      var v = variants[key];
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (imgEl && v.image) imgEl.src = v.image;
      if (addBtn) addBtn.disabled = !v.available;
      if (titleEl) titleEl.textContent = productTitle + (hasVariants && v.title ? ' · ' + v.title : '');
    }

    // Empire's <variant-selection> dispatcht een 'variant-change' CustomEvent (geen native change).
    var vsel = document.querySelector('[data-variant-selection]');
    if (vsel) {
      vsel.addEventListener('variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.id) sync(v.id);
      });
    }
    // Fallback: native change op het id-veld.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') sync();
    });

    // Tonen zodra de hoofd add-to-cart-knop uit beeld is.
    if (atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) bar.setAttribute('hidden', '');
          else bar.removeAttribute('hidden');
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(atcBtn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
